// Libraries
import styled from 'styled-components'

export const VideoContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: rgba(43, 42, 99, 0.45);
`
export const Cell = styled.td`
  padding: 4px 0;
`

export const Row = styled.tr``

export const InputWrapper = styled.div`
  input {
    cursor: pointer;
    padding: 12px 0;
  }
`
